export const menu = {
    label: 'FE 2026',
    icon: 'pi pi-calendar',
    to: '/checkins/feiraempreendedor/atendimento',
    rules: ['CHECKINS-INSCRICOES-02'],
};

export default menu;